export function exportToCsv<T extends Record<string, any>>(
  filename: string,
  data: T[],
  headersMap?: Record<string, string>
) {
  if (!data || data.length === 0) return;

  const headers = Object.keys(data[0]);
  const displayHeaders = headersMap 
    ? headers.map(h => headersMap[h] || h)
    : headers;

  const csvRows = [];
  
  // Header row
  csvRows.push(displayHeaders.map(header => `"${String(header).replace(/"/g, '""')}"`).join(','));

  // Data rows
  for (const row of data) {
    const values = headers.map(header => {
      const val = row[header];
      if (val === null || val === undefined) return '""';
      
      // format dates nicely
      if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
        return `"${new Date(val).toLocaleString()}"`;
      }
      
      return `"${String(val).replace(/"/g, '""')}"`;
    });
    csvRows.push(values.join(','));
  }

  const csvContent = '\uFEFF' + csvRows.join('\n'); // Add BOM for Excel UTF-8 support
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
